<template>
  <div class="pt100 ta-c">
    <!-- 플라이빗 앱으로 바로 연결 -->
    신원인증을 진행합니다.
  </div>
</template>
<script>
export default {
  created() {
    // location.href =
    //   "Intent://flybit?type=certification#Intent;scheme=app;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.flybit.app;end";
    // location.href = "https://m.dev.flybit.com";
  },
  data() {
    return {
      isiOS: false,
      isAOS: false,
      pageName: window.location.href.split("?")[1],
    };
  },

  mounted() {
    this.checkDevice();

    const AOSdevUrl = `Intent://flybit?${this.pageName}#Intent;scheme=app;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.flybit.app.dev;end`;
    const AOSliveUrl = `Intent://flybit?${this.pageName}#Intent;scheme=app;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.flybit.app;end`;
    // const iOSdevUrl = `Intent://flybit?${this.pageName}#Intent;scheme=app;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.flybit.app.dev;end`;
    // const iOSliveUrl = `Intent://flybit?${this.pageName}#Intent;scheme=app;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.flybit.app;end`;

    // location.href = AOSliveUrl;

    if (window.location.host.indexOf("dev.") !== -1) {
      // console.log("aos-dev");
      // alert("aos-dev");
      location.href = AOSdevUrl;
    } else {
      // console.log("aos-dev");
      // alert("aos-dev");
      location.href = AOSliveUrl;
    }
    // if (this.isAOS) {
    //   alert("aos");
    //   // AOS
    //   if (window.location.host.indexOf("dev.") !== -1) {
    //     // console.log("aos-dev");
    //     alert("aos-dev");
    //     location.href = AOSdevUrl;
    //   } else {
    //     // console.log("aos-else");
    //     alert("aos-else");
    //     location.href = AOSliveUrl;
    //   }
    // } else if (this.isiOS) {
    //   // console.log("ios");
    //   return alert("안드로이드 기종에서만 가능합니다.");
    //   iOS
    //     if (window.location.host.indexOf("dev.") !== -1) {
    //       // console.log("ios-dev");
    //       // alert("ios-dev");
    //       location.href = "https://mobile-auth.dev.flybit.com/mypage/confirm";
    //     } else if (window.location.host.indexOf("stg") !== -1) {
    //       // console.log("ios-stg");
    //       // alert("ios-stg");
    //       location.href = "https://m.stg.flybit.com/mypage/confirm"; // stg 서버
    //     } else {
    //       // console.log("aos-else");
    //       // alert("ios-else");
    //       location.href = "https://m.flybit.com/mypage/confirm"; // 라이브
    //     }
    //   } else {
    //     // alert("else");
    //     location.href = "https://m.flybit.com/mypage/confirm"; // 라이브
    // }
  },

  methods: {
    checkDevice() {
      const agent = navigator.userAgent;

      agent.indexOf("iPhone") > 0 ? (this.isiOS = true) : (this.isiOS = false);
      agent.indexOf("Android") > 0
        ? (this.isAndroid = true)
        : (this.isAndroid = false);
    },
  },
  /*
  기본 어플 연결
  Intent://flybit#Intent;scheme=app;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.flybit.app.dev;end"

  특정 페이지 연결(?type=certification 추가)
  Intent://flybit?type=certification#Intent;scheme=app;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.flybit.app.dev;end"
  */
};
</script>
<style lang="scss" scoped></style>
